const JSZip = require('jszip');
const shpwrite = require('shp-write');

export function customZip (gj, options, filename) {

    var zip = new JSZip(),
        layers = zip.folder(options && options.folder ? options.folder : 'layers');

    [justType('Point', 'POINT', gj), justType('LineString', 'POLYLINE',gj), justType('Polygon', 'POLYGON', gj)]
        .forEach(function(l) {
        if (l.geometries.length && l.geometries[0].length) {
            shpwrite.write(
                // field definitions
                l.properties,
                // geometry type
                l.type,
                // geometries
                l.geometries,
                function(err, files) {
                    var fileName = options && options.types[l.type.toLowerCase()] ? options.types[l.type.toLowerCase()] : l.type;
                    layers.file(fileName + '.shp', files.shp.buffer, { binary: true });
                    layers.file(fileName + '.shx', files.shx.buffer, { binary: true });
                    layers.file(fileName + '.dbf', files.dbf.buffer, { binary: true });
                    layers.file(fileName + '.prj', 'GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137,298.257223563]],PRIMEM["Greenwich",0],UNIT["Degree",0.017453292519943295]]');
                });
        }
    });

    zip.generateAsync({type: 'blob'}).then(function(content) {
        // see FileSaver.js
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(content);
        link.download = filename;
        link.click();
    });
}

function justType (type, TYPE, gj) {
    
    var oftype = gj.features.filter(isType(type));
    var geometries;
    if (TYPE === 'POLYGON') {
        // geometries = [oftype.map(justCoords)];
        geometries = oftype.map(function(t) { return [justCoords(t)]; });
    } else if (TYPE === 'POLYLINE') {
        geometries = oftype.map(function(t) { return [justCoords(t)]; });
    } else {
        geometries = oftype.map(justCoords);
    }
    return {
        geometries: geometries,
        properties: oftype.map(justProps),
        type: TYPE
    };
    
}

function justCoords (t) {
    if (t.geometry.coordinates[0] !== undefined &&
        t.geometry.coordinates[0][0] !== undefined &&
        t.geometry.coordinates[0][0][0] !== undefined) {
        return t.geometry.coordinates[0];
    } else {
        return t.geometry.coordinates;
    }
}

function justProps (t) {
    return t.properties;
}

function isType (t) {
    return function(f) { return f.geometry.type === t; };
}